// extracted by mini-css-extract-plugin
module.exports = {"input":"styles__input___3U8Pu"};